import { render, staticRenderFns } from "./FacebookPlatformIcon.vue?vue&type=template&id=581719a3&scoped=true"
import script from "./FacebookPlatformIcon.vue?vue&type=script&lang=js"
export * from "./FacebookPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581719a3",
  null
  
)

export default component.exports